import * as React from "react";
import { Pill } from "@/components/ui/pill";
import {
  planAdherenceBands,
  type PlanAdherenceVerdictId,
} from "@/features/oee/plan-adherence-verdict";
import { usePlanAdherenceBounds } from "@/hooks/useOrganizationPolicy";
import { cn } from "@/lib/utils";

export interface PlanAdherenceVerdictBandsProps {
  basis: "in-progress" | "completed";
  activeId: PlanAdherenceVerdictId | null;
}

export function PlanAdherenceVerdictBands({
  basis,
  activeId,
}: PlanAdherenceVerdictBandsProps): React.ReactElement {
  // Spec 079 (FR-036) — as faixas EXIBIDAS são derivadas dos limiares VIGENTES. Enquanto elas
  // traziam "< 95%" escrito à mão, uma fábrica com piso 90 lia a legenda contradizendo o crachá
  // que a legenda existe para explicar.
  const bands = planAdherenceBands(usePlanAdherenceBounds()).filter((b) => b.appliesTo === basis);
  return (
    <ul
      className="bg-bg-muted-rd/40 divide-y divide-border-subtle rounded border"
      aria-label="Faixas do veredito"
    >
      {bands.map((b) => {
        const active = b.id === activeId;
        return (
          <li
            key={b.id}
            data-band-id={b.id}
            data-active={active}
            aria-current={active ? "true" : undefined}
            className={cn("px-2 py-1.5", active && "bg-brand-50")}
          >
            <div className="flex items-center justify-between gap-2 text-[12px]">
              <span className="inline-flex items-center gap-1.5">
                <Pill tone={b.tone} withDot={active}>
                  {b.label}
                </Pill>
                <span className="font-mono text-text-tertiary">{b.range}</span>
              </span>
              {active ? (
                <span className="text-[11px] font-semibold uppercase tracking-wider text-brand-600">
                  atual
                </span>
              ) : null}
            </div>
            <p className="mt-0.5 text-[12px] text-text-tertiary">{b.description}</p>
          </li>
        );
      })}
    </ul>
  );
}
